export enum PlayerStatus {
  ONLINE = 'Online',
  AWAY = 'Away',
  DO_NOT_DISTURB = 'Do Not Disturb',
} 